import React from "react"
import { useAtomValue } from "jotai"
import { networkAtom } from "@/atoms/settings"
import View from "./view"

const Container = () => {
  const network = useAtomValue(networkAtom)

  return <View network={network} />
}

export default Container
